module.exports = __webpack_public_path__ + "lato-black-f80bda6afd19534368443a3d0323a140.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-black/lato-black.woff
// module id = 1067
// module chunks = 0